import { useState } from 'react';
import { Shield, Clock, Sparkles, Star, Check, ChevronRight, ChevronDown, Smartphone, Battery, Camera, PlugZap, Square } from 'lucide-react';

const HeroSection = () => {
  const [selectedModel, setSelectedModel] = useState('');

  const scrollToDevis = () => {
    const element = document.querySelector('#devis');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContinue = () => {
    if (selectedModel) {
      window.__alloRepHeroModel = selectedModel;
      // Dispatch custom event to notify QuoteConfigurator
      window.dispatchEvent(new CustomEvent('allorep:hero-model-selected'));
    }
    scrollToDevis();
  };

  const trustBadges = [
    { icon: Clock, text: 'Réparation en 30 min' },
    { icon: Shield, text: 'Garantie 6 mois' },
  ];

  const iphoneGroups = [
    { label: 'iPhone 17', models: ['iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17'] },
    { label: 'iPhone 16', models: ['iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 16e'] },
    { label: 'iPhone 15', models: ['iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15'] },
    { label: 'iPhone 14', models: ['iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14'] },
    { label: 'iPhone 13', models: ['iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 Mini'] },
    { label: 'iPhone 12', models: ['iPhone 12 Pro Max', 'iPhone 12 / 12 Pro', 'iPhone 12 Mini'] },
    { label: 'iPhone 11', models: ['iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11'] },
    { label: 'iPhone X', models: ['iPhone XS Max', 'iPhone X / XS', 'iPhone XR'] },
    { label: 'iPhone 8 / SE', models: ['iPhone 8 / 8 Plus / SE2 / SE3'] },
  ];

  /* Exact per-model prices (matching QuoteConfigurator) */
  const MODEL_PRICES = {
    'iPhone 8 / 8 Plus / SE2 / SE3': { screen: 45, back: 60, battery: 25, charge: 45, camera: 45 },
    'iPhone X / XS':                 { screen: [55,69], back: 65, battery: 45, charge: 45, camera: 45 },
    'iPhone XS Max':                 { screen: [65,95], back: 70, battery: 50, charge: 45, camera: 45 },
    'iPhone XR':                     { screen: [65,99], back: 80, battery: 45, charge: 49, camera: 49 },
    'iPhone 11':                     { screen: [65,99], back: 80, battery: 45, charge: 49, camera: 49 },
    'iPhone 11 Pro':                 { screen: [75,120], back: 85, battery: 55, charge: 59, camera: 69 },
    'iPhone 11 Pro Max':             { screen: [85,120], back: 90, battery: 55, charge: 69, camera: 79 },
    'iPhone 12 / 12 Pro':            { screen: [85,125], back: 95, battery: 60, charge: 59, camera: 59 },
    'iPhone 12 Mini':                { screen: [85,120], back: 90, battery: 60, charge: 59, camera: 89 },
    'iPhone 12 Pro Max':             { screen: [90,135], back: 95, battery: 60, charge: 59, camera: 109 },
    'iPhone 13':                     { screen: [95,125], back: 100, battery: 65, charge: 69, camera: 59 },
    'iPhone 13 Mini':                { screen: [95,165], back: 100, battery: 65, charge: 49, camera: 89 },
    'iPhone 13 Pro':                 { screen: [120,165], back: 110, battery: 65, charge: 59, camera: 119 },
    'iPhone 13 Pro Max':             { screen: [130,175], back: 95, battery: 60, charge: 69, camera: 119 },
    'iPhone 14':                     { screen: [99,135], back: 95, battery: 70, charge: 69, camera: 89 },
    'iPhone 14 Pro':                 { screen: [109,149], back: 135, battery: 80, charge: 69, camera: 89 },
    'iPhone 14 Pro Max':             { screen: [119,159], back: 140, battery: 85, charge: 69, camera: 99 },
    'iPhone 14 Plus':                { screen: [99,150], back: 90, battery: 75, charge: 79, camera: 79 },
    'iPhone 15':                     { screen: [99,175], back: 99, battery: 80, charge: 69, camera: 89 },
    'iPhone 15 Pro':                 { screen: [110,155], back: 110, battery: 90, charge: 79, camera: 99 },
    'iPhone 15 Pro Max':             { screen: [120,195], back: 115, battery: 99, charge: 79, camera: 109 },
    'iPhone 15 Plus':                { screen: [99,180], back: 99, battery: 85, charge: 69, camera: 89 },
    'iPhone 16':                     { screen: [149,190], back: 99, battery: 80, charge: 79, camera: 99 },
    'iPhone 16 Pro':                 { screen: [180,240], back: 110, battery: 89, charge: 69, camera: 109 },
    'iPhone 16 Pro Max':             { screen: [195,249], back: 120, battery: 99, charge: 79, camera: 109 },
    'iPhone 16e':                    { screen: [109,130], back: 119, battery: 80, charge: 79, camera: 99 },
    'iPhone 16 Plus':                { screen: [109,209], back: 109, battery: 85, charge: 59, camera: 99 },
    'iPhone 17':                     { screen: [159,199], back: 149, battery: 80, charge: 130, camera: 140 },
    'iPhone 17 Pro':                 { screen: [199,229], back: 149, battery: 85, charge: 130, camera: 140 },
    'iPhone 17 Pro Max':             { screen: [209,259], back: 169, battery: 90, charge: 140, camera: 140 },
    Autre: { screen: [45,259], back: [60,169], battery: [25,99], charge: [45,140], camera: [45,140] },
  };

  const ISSUES = [
    { key: 'screen',  label: 'Écran',             Icon: Smartphone },
    { key: 'back',    label: 'Vitre arrière',     Icon: Square },
    { key: 'battery', label: 'Batterie',          Icon: Battery },
    { key: 'charge',  label: 'Connecteur charge', Icon: PlugZap },
    { key: 'camera',  label: 'Caméra',            Icon: Camera },
  ];

  const prices = selectedModel ? MODEL_PRICES[selectedModel] : null;

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden"
      data-testid="hero-section"
    >
      {/* Light base background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50/30" />

      {/* Soft mesh gradient */}
      <div
        className="absolute inset-0 opacity-70 pointer-events-none"
        style={{
          background: `
            radial-gradient(ellipse at 20% 20%, rgba(0, 82, 255, 0.08) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 25%, rgba(6, 182, 212, 0.08) 0%, transparent 55%),
            radial-gradient(ellipse at 60% 85%, rgba(139, 92, 246, 0.06) 0%, transparent 55%)
          `,
        }}
      />

      {/* Subtle animated blobs */}
      <div className="absolute top-24 -right-16 w-[420px] h-[420px] bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-full blur-3xl animate-pulse pointer-events-none" style={{ animationDuration: '9s' }} />
      <div className="absolute -bottom-20 -left-16 w-[360px] h-[360px] bg-gradient-to-br from-cyan-400/15 to-green-400/15 rounded-full blur-3xl animate-pulse pointer-events-none" style={{ animationDuration: '11s', animationDelay: '2s' }} />

      {/* Main content */}
      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-10 lg:gap-14 items-center">
          {/* Left — Copy */}
          <div className="order-2 lg:order-1">
            {/* Top badges */}
            <div className="flex flex-wrap items-center gap-2.5 mb-6">
              <div
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-amber-100 to-orange-100 border border-amber-200/60"
                data-testid="urgency-badge"
              >
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-70 animate-ping" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" />
                </span>
                <span className="text-[11px] font-semibold text-amber-700 uppercase tracking-[0.12em]">
                  Disponible aujourd'hui
                </span>
              </div>
              <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gradient-to-r from-purple-100 to-blue-100 border border-purple-200/50">
                <Sparkles size={12} className="text-purple-600" />
                <span className="text-[11px] font-semibold text-purple-700 uppercase tracking-[0.12em]">
                  Montpellier
                </span>
              </div>
            </div>

            {/* Headline */}
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.05] mb-6 tracking-tight"
              data-testid="hero-headline"
            >
              Réparation{' '}
              <span className="gradient-text-animated">express</span>
              <br />
              iPhone, Samsung & ordinateur
              <br />
              <span className="text-3xl sm:text-4xl lg:text-5xl text-slate-600 font-semibold">à Montpellier</span>
            </h1>

            {/* Subheadline */}
            <p
              className="text-base sm:text-lg text-slate-600 leading-relaxed mb-8 max-w-xl"
              data-testid="hero-subheadline"
            >
              Écran cassé, batterie HS, micro-soudure&nbsp;? Toutes marques (iPhone, Samsung, Huawei, Xiaomi, MacBook…). Devis gratuit, réparation en 30 min,{' '}
              <span className="text-slate-900 font-semibold">garantie 6 mois</span>.
            </p>

            {/* Trust strip */}
            <div className="flex flex-wrap gap-2" data-testid="trust-badges">
              {trustBadges.map((badge, index) => (
                <div
                  key={index}
                  className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-slate-200 shadow-sm"
                  data-testid={`trust-badge-${index}`}
                >
                  <badge.icon size={14} className="text-blue-600" />
                  <span className="text-xs font-medium text-slate-700">{badge.text}</span>
                </div>
              ))}
              <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-slate-200 shadow-sm">
                <div className="flex gap-0.5">
                  {[...Array(4)].map((_, i) => (
                    <Star key={i} size={11} className="fill-amber-400 text-amber-400" />
                  ))}
                  <Star size={11} className="fill-amber-400/60 text-amber-400/60" />
                </div>
                <span className="text-xs font-medium text-slate-700">
                  <span className="font-bold text-slate-900">4.7</span>
                  <span className="text-slate-500">/5</span> Google
                </span>
              </div>
              <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-slate-200 shadow-sm">
                <span className="text-xs font-medium text-slate-700">
                  <span className="font-bold text-slate-900">+2500</span> réparations
                </span>
              </div>
            </div>
          </div>

          {/* Right — Mini teaser (light card) */}
          <div className="order-1 lg:order-2 relative" data-testid="hero-teaser">
            {/* Soft glow behind card */}
            <div className="absolute -inset-2 bg-gradient-to-br from-blue-500/15 via-indigo-500/10 to-cyan-500/15 rounded-[36px] blur-2xl pointer-events-none" />

            <div className="relative rounded-3xl p-6 sm:p-7 shadow-2xl shadow-blue-900/30 overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/20 border border-blue-400/30 mb-3">
                <Sparkles size={12} className="text-cyan-300" />
                <span className="text-[11px] font-bold text-blue-100 uppercase tracking-wider">
                  Devis en 30 secondes
                </span>
              </div>

              <h2 className="text-xl sm:text-2xl font-bold text-white mb-1">
                Votre iPhone, votre devis
              </h2>
              <p className="text-sm text-slate-300 mb-5">
                Choisissez votre modèle pour démarrer.
              </p>

              <label
                htmlFor="hero-teaser-select"
                className="block text-[11px] font-bold text-slate-300 mb-2 uppercase tracking-wider"
              >
                Modèle d'iPhone
              </label>
              <div className="relative mb-4">
                <select
                  id="hero-teaser-select"
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                  className="w-full appearance-none px-4 py-3.5 pr-11 rounded-xl bg-white border-2 border-slate-200 text-slate-900 font-medium focus:border-blue-500 focus:ring-4 focus:ring-blue-500/15 focus:outline-none cursor-pointer transition-all"
                  data-testid="hero-teaser-select"
                >
                  <option value="">— Choisissez votre iPhone —</option>
                  {iphoneGroups.map((g) => (
                    <optgroup key={g.label} label={g.label}>
                      {g.models.map((m) => (
                        <option key={m} value={m}>
                          {m}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                  <option value="Autre">Autre / je ne sais pas</option>
                </select>
                <ChevronDown
                  size={18}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
                />
              </div>

              {!selectedModel && (
                <>
                  <button
                    disabled
                    className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl font-semibold text-white/40 bg-white/5 border border-white/10 cursor-not-allowed"
                    data-testid="hero-teaser-cta"
                  >
                    Obtenir mon devis gratuit
                    <ChevronRight size={18} />
                  </button>

                  <div className="flex items-center justify-center gap-4 mt-4 text-xs text-slate-400">
                    <div className="flex items-center gap-1.5">
                      <Check size={12} className="text-green-400" />
                      <span>Instantané</span>
                    </div>
                    <span className="text-white/20">·</span>
                    <div className="flex items-center gap-1.5">
                      <Shield size={12} className="text-green-400" />
                      <span>Garantie 6 mois</span>
                    </div>
                    <span className="text-white/20">·</span>
                    <div className="flex items-center gap-1.5">
                      <Clock size={12} className="text-green-400" />
                      <span>30 min</span>
                    </div>
                  </div>
                </>
              )}

              {selectedModel && prices && (
                <div data-testid="hero-price-ranges">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-[11px] font-bold text-slate-300 uppercase tracking-wider">
                      Prix de réparation
                    </span>
                    <span className="text-[10px] text-slate-400 uppercase tracking-wider">
                      à partir de
                    </span>
                  </div>

                  <div className="rounded-xl p-3 mb-4 space-y-1 bg-white/[0.04] border border-white/10">
                    {ISSUES.map((issue, idx) => {
                      const val = prices[issue.key];
                      const isRange = Array.isArray(val);
                      const IssueIcon = issue.Icon;
                      return (
                        <div
                          key={issue.key}
                          className={`flex items-center justify-between py-1.5 ${
                            idx < ISSUES.length - 1 ? 'border-b border-white/5' : ''
                          }`}
                        >
                          <span className="flex items-center gap-2 text-sm text-slate-200">
                            <IssueIcon size={15} className="text-slate-400" />
                            <span>{issue.label}</span>
                          </span>
                          <span className="font-semibold text-white text-sm tabular-nums">
                            {isRange ? `${val[0]}–${val[1]}` : val}<span className="text-slate-400 ml-0.5">€</span>
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  <button
                    onClick={handleContinue}
                    className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl font-semibold text-white bg-gradient-to-r from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/40 hover:shadow-xl hover:shadow-blue-500/50 hover:-translate-y-0.5 transition-all duration-300"
                    data-testid="hero-teaser-cta"
                  >
                    Obtenir un devis précis
                    <ChevronRight size={18} />
                  </button>

                  <p className="text-[11px] text-slate-400 mt-3 text-center leading-relaxed">
                    Prix de départ. Le devis final dépend de l'état de l'appareil et des pièces choisies.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
